import { Block, Typography } from '@aloft/toolkit-sui';

export function PairedTwoLineCell({
  primary,
  secondary,
}: {
  primary: string;
  secondary: string;
}) {
  return (
    <Block>
      <Typography variant="body2" __dangerDoNotUseSx={{ fontWeight: 600 }}>
        {primary}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {secondary}
      </Typography>
    </Block>
  );
}
